import React, { FC, useRef } from 'react'
import images from '../../../../app/utlis/image';
import { getImage } from '../../../../app/utlis/imageConstants';
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg';
import { motion, useInView } from 'framer-motion'

interface MoodyMonthContentProps {
    moodyProjectData: any
}

const MoodyMonthContent: FC<MoodyMonthContentProps> = ({ moodyProjectData }) => {
    const bannerRef = useRef(null);
    const detailsRef = useRef(null);
    const isBannerInView = useInView(bannerRef, { once: false });
    const isDetailsInView = useInView(detailsRef, { once: false });

    const bannerVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: { 
            opacity: 1,
            transition: { 
                staggerChildren: 0.2,
                delayChildren: 0.3
            } 
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    return (
        <div>
            <div className='px-4 sm:px-6 md:px-12'>
                <motion.div 
                    ref={bannerRef}
                    variants={bannerVariants}
                    initial="hidden"
                    animate={isBannerInView ? "visible" : "hidden"}
                    className="w-full"
                >
                    <img src={images.MOODYBANNERIMAGE} className="w-full h-auto" alt="Moody Banner" />
                </motion.div>
                <motion.div 
    className='grid grid-cols-2 md:grid-cols-4 gap-4 p-6 md:p-12 lg:p-20 pt-8 md:pt-16'
    ref={detailsRef}
    variants={containerVariants}
    initial="hidden"
    animate={isDetailsInView ? "visible" : "hidden"}
>
    {moodyProjectData.moodyProjectDetails.websiteDetails.map((detail: any, index: number) => {
        let img = getImage(detail?.image ?? "") ?? "";
        return (
            <motion.div
                key={index}
                variants={itemVariants}
                whileHover={{ 
                    scale: 1.05, 
                    transition: { duration: 0.3 }
                }}
            >
                <div className='p-4 md:p-6 rounded-3xl flex flex-col justify-start items-center gap-4 w-full h-full'>
                    <motion.div 
                        className='w-14 h-14 md:w-20 md:h-20 rounded-full flex items-center justify-center bg-white'
                        whileHover={{ rotate: 5 }}
                        transition={{ type: "spring", stiffness: 400, damping: 10 }}
                    >
                        <div className='flex items-center justify-center text-black font-black text-lg md:text-xl'>
                            <DynamicSVG color='#37B9AB'>{img}</DynamicSVG>
                        </div>
                    </motion.div>
                    <div className='flex flex-col justify-center items-center gap-1 text-center'>
                        <span className='text-base md:text-xl font-medium text-white'>
                            <b>{detail.title}</b>
                        </span>
                        <span className='text-xs md:text-base text-[#E0E0E0]'>
                            {detail.sub_title}
                        </span>
                    </div>
                </div>
            </motion.div>
        )
    })}
</motion.div>
            </div>
        </div>
    )
}

export default MoodyMonthContent
